import { Component, PropsWithChildren } from 'react';

import { t } from '@onlinepayments/payments-library';
import { captureException } from '@sentry/browser';

import constructionImage from '../../../assets/images/ill-construction.svg';
import Card from '../Card';
import FullPageMessage from '../FullPageMessage';

interface State {
  hasError: boolean;
}

// Return a full page error message if there is a
// JavaScript runtime error that breaks the application.
class ErrorBoundary extends Component<PropsWithChildren<object>, State> {
  constructor(props: object) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: Record<string, any>) {
    console.error(errorInfo);
    captureException(error, (scope) => scope.setLevel('fatal'));
  }

  render() {
    if (this.state.hasError) {
      return (
        <Card>
          <FullPageMessage
            title={t('generic_error_message')}
            imgProps={{ src: constructionImage }}
          />
        </Card>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
